// Marca Bheli: isotipo «Módulos» con wordmark en texto vivo y loader de los 4 módulos (Bheli.Web.Feedback/Components/Brand).

type LogoVariant = "isotipo" | "horizontal" | "vertical";
type LogoTheme = "auto" | "light" | "dark" | "mono-black" | "mono-white" | "one-color";

export function BheliLogo({
  variant = "isotipo",
  theme = "auto",
  size = 24,
  title,
  className,
}: {
  variant?: LogoVariant;
  theme?: LogoTheme;
  size?: number;
  title?: string;
  className?: string;
}) {
  const height = Math.max(16, size);
  const wordmark = variant === "horizontal" || variant === "vertical";
  return (
    <span
      className={`bheli-logo bheli-logo--${variant} bheli-logo--theme-${theme} ${className ?? ""}`}
      data-logo-size={height}
      style={{ "--logo-size": height } as React.CSSProperties}
    >
      <svg
        className="bheli-logo__mark"
        viewBox="0 0 96 96"
        width={height}
        height={height}
        focusable="false"
        role={wordmark ? undefined : "img"}
        aria-label={wordmark ? undefined : title?.trim() || "Bheli"}
        aria-hidden={wordmark ? true : undefined}
      >
        {title?.trim() ? <title>{title}</title> : null}
        <path className="bheli-logo__top" d="M9 9 L39 45 L9 45 Z" />
        <path className="bheli-logo__top" d="M87 9 L87 45 L57 45 Z" />
        <path className="bheli-logo__bottom" d="M9 51 H45 V87 A36 36 0 0 1 9 51 Z" />
        <path className="bheli-logo__bottom" d="M51 51 H87 A36 36 0 0 1 51 87 Z" />
      </svg>
      {wordmark ? <span className="bheli-logo__wordmark">Bheli</span> : null}
    </span>
  );
}

/** Loader de marca: tamaños 16, 24, 32 o 48 (otro valor usa 24). La etiqueta localizada la pasa quien lo usa. */
export function BheliLoader({
  size = 24,
  theme = "light",
  label,
  className,
}: {
  size?: number;
  theme?: "light" | "dark";
  label: string;
  className?: string;
}) {
  const px = [16, 24, 32, 48].includes(size) ? size : 24;
  return (
    <span
      className={`bheli-loader bheli-loader--${px} bheli-loader--theme-${theme} ${className ?? ""}`}
      role="status"
      aria-label={label}
    >
      <svg viewBox="0 0 96 96" width={px} height={px} focusable="false" aria-hidden="true">
        <path className="bheli-logo__top bheli-loader__m1" d="M9 9 L39 45 L9 45 Z" />
        <path className="bheli-logo__top bheli-loader__m2" d="M87 9 L87 45 L57 45 Z" />
        <path className="bheli-logo__bottom bheli-loader__m3" d="M9 51 H45 V87 A36 36 0 0 1 9 51 Z" />
        <path className="bheli-logo__bottom bheli-loader__m4" d="M51 51 H87 A36 36 0 0 1 51 87 Z" />
      </svg>
    </span>
  );
}
